import { ShoppingCartService } from './../../shared/services/shopping-cart.service';
import { Component, OnInit, OnDestroy, HostListener, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { HostedpaymentDialogComponent } from '../../shared/model/hostedpayment-dialog/hostedpayment-dialog.component';
import { NotificationService } from '../../shared/services/notification.service';
import { PaymentService } from '../../shared/services/payment.service';
import { ProductService } from '../../shared/services/product.service';
import { RestApiService } from '../../shared/services/restapi.service';
import { UserService } from '../../shared/services/user.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ApplicantAddress, Enrollment } from 'src/app/modals/enrollment.model';
import { EnrollmentResponse } from 'src/app/modals/enrollmentrespnse.modal';
import { Title } from '@angular/platform-browser';
import { ConfigService } from '../../shared/services/config.service';
import { UtilityService } from '../../shared/services/utility.service';
import { Cart1Service } from '../../shared/services/cart1.service';
import { UserServiceModal, ShippingAddress } from 'src/app/modals/userservice.modal';
import { OrderService } from '../../shared/services/order.service';
import { DSProduct } from 'src/app/modals/dsproduct.modal';
import { ValidateKeywordService } from '../../shared/services/validatekeyword.service';
import { ItemsListService } from '../../shared/services/itemsList.service';
import $ from 'jquery';
import { Location } from '@angular/common';
import { RegexService } from '../../shared/services/regex.service';
import { AutoshipConfigurationService } from '../../shared/services/autoshipConfiguration.service';
import { CompanyService } from '../../shared/services/company.service';
import { AccountService } from '../../shared/services/account.service';
import { PersistentService } from '../../shared/services/persistent.service';
import { JoiningdialogComponent } from '../../shared/joiningdialog/joiningdialog.component';
import { MatStepper } from "@angular/material/stepper";
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DefaultCountry, FreeEnrollmentItemID, FreeEnrollmentZeroPriceItemID, IBOSTOREID, ENROLLMENTSTORE } from 'src/app/constant';
import { StoreConstantsService } from '../../shared/services/store-constants.service';
declare function OnIFrameSave(e): any;

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class ApplicationComponent implements OnInit, OnDestroy {
  showError: boolean = false;
  content_display: string;
  userService: UserServiceModal;
  enrollmentForm: Enrollment;
  IsSubmitDisable: boolean = false;
  loadingDetails: boolean = true;
  SubmitApplicationResponse: any = {};
  memberTypes = [];
  submitApplicationRequest: Enrollment;
  frequencyTypeID: number = 0;
  IsAllowKitItems: boolean = true;
  OrderItemRequired: boolean = true;
  allowedCountries: any = [];
  selectedCountry: string = 'us';
  product: Array<DSProduct> = [];
  public country: any;
  public userType: any;
  selectedLanguageCode: any;
  selectedState: string = 'UT';
  model: any = {};
  days = [];
  months = [];
  years = [];
  selectedStateControl = new FormControl(this.selectedState);
  panelShippingAddress: boolean = true;
  panelAccountInfo: boolean = false;
  panelPaymentMethod: boolean = false;
  noOfStepsVerified: number = 0;
  UserNameCheck: any;
  ApplicationSteps: any = {};
  public currentStep: any;
  isShowUpDown: any[] = [];
  CurrentSection: any = {};
  finalStep: any;
  ProductOrderNumber:any;
  typeSelected: any;
  lastQuantity: 0;
  public commonData: any;
  public AutoshipMinDate: Date;
  public AutoshipMaxDate: Date;
  selectedfrequencyTypeID: 0;
  ReplicatedSiteUrl: string = 'Tangerine.fun';
  checkboxes: any = {};
  StatesResponse: [];
  StateNameToggel: boolean = false;
  isPanelOpen: boolean = false;
  productsAutoshipStore: Array<DSProduct> = []
  productskitStore: Array<DSProduct> = []
  productswholesaleStore: Array<DSProduct> = []
  productsretailPrice_autoship: Array<DSProduct> = []
  productsretailPrice_kit: Array<DSProduct> = []
  productsretailPrice_wholesale: Array<DSProduct> = []
  defaultproducts: Array<DSProduct> = []
  RegionIDForRequest: number
  CollapseToggleEnrollment:boolean = false
  CollapseToggleTodays:boolean = false
  CollapseToggleLoyalty:boolean = false
  paymentMerchantData:any
  FreeEnrollmentItemID: any = FreeEnrollmentItemID;
  FreeEnrollmentZeroPriceItemID: any = FreeEnrollmentZeroPriceItemID;
  scrollContent: any[] = [];
  
  // URL properties for links
  privacyPolicyUrl: string = '';
  termsOfServiceUrl: string = '';
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  constructor(
    public utilityService: UtilityService,
    private titleService: Title,
    public configService: ConfigService,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public itemsService: ProductService,
    public apiService: RestApiService,
    public user: UserService,
    public notificationService: NotificationService,
    public paymentService: PaymentService,
    public translate: TranslateService,
    public cart1Service: Cart1Service,
    public orderService: OrderService,
    public validateKeyword: ValidateKeywordService,
    public itemsListService: ItemsListService,
    public location: Location,
    public regexService: RegexService,
    public router: Router,
    public autoshipConfigurationService: AutoshipConfigurationService,
    public companyService: CompanyService,
    public accountService: AccountService,
    public shoppingCartService: ShoppingCartService,
    public persistentService: PersistentService,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private storeConstantsService: StoreConstantsService
  ) {
    this.userService = this.user.userServiceModal;
    this.apiService.getActiveCountries().subscribe(data => {
      this.allowedCountries = data.Data ?? data;
      if(this.allowedCountries?.length > 0){
        this.allowedCountries = this.allowedCountries.filter(ac => ac.CountryCode?.toLowerCase() !== "jp");
      }
      const selectedCountry = sessionStorage.getItem('selectedCountry') === 'undefined' ? null : sessionStorage.getItem('selectedCountry');
      const selectedCustomerTypeID = sessionStorage.getItem('selectedCustomerTypeID') === 'undefined' ? null : sessionStorage.getItem('selectedCustomerTypeID');
      this.selectedLanguageCode = sessionStorage.getItem('selectedLanguageCode');

      // const userType = _.find(configService.commonSettings.CustomerTypes, (customerType) => {
      //   return (customerType.ID === (parseInt(this.route.snapshot.queryParams.type, 10) || this.typeSelected || parseInt(selectedCustomerTypeID, 10) || 2));
      // });

      this.userService.customerTypeID = 1;
      this.route.queryParams.subscribe((type: any) => {
        this.userType = parseInt(type.type) || this.userService.customerTypeID || 1
        localStorage.setItem('userService', JSON.stringify(this.userService));
      })
      const country = _.find(this.allowedCountries, (item) => {
        return (item.CountryCode.toLowerCase() === (selectedCountry?.toLowerCase() || 'us'));
      });
      this.country = country;
      this.configService.getCommonSetting(this.country.CountryCode, this.selectedLanguageCode || this.commonData.selectedLanguage).then(() => {
        this.RegionIDForRequest = this.companyService.getRegionID(this.country.CountryCode)
        if (this.userService.customerTypeID == 3) {
          this.itemsForCustomerPC();
        } else if (this.userService.customerTypeID == 1) {
          this.itemsForCustomerIBO();
        }
        // Only load existing payment methods if user is logged in (not for new enrollment)
        if (this.userService.customerData && this.userService.customerData.CustomerId) {
          this.paymentService.getPaymentType(true).then(() => {
            this.userService.paymentMethods = this.userService.paymentMethods || [];
            this.userService.couponInfo.promoCodeValid = undefined;
            this.paymentService.PaymentDataResponse = this.paymentService.PaymentDataResponse || {};
            // If they've already set up a split payment and try to add autoship items, only allow one payment method
            if (this.countPaymentMethods() > 1) {
              this.userService.paymentMethods = [this.userService.paymentMethods[0]];
            }
          });
        } else {
          // For new enrollment, ensure payment methods array is empty
          this.userService.paymentMethods = [];
          this.userService.couponInfo.promoCodeValid = undefined;
          this.paymentService.PaymentDataResponse = this.paymentService.PaymentDataResponse || {};
          
          // Still need to load payment types for the "Add Payment Method" options
          this.paymentService.getPaymentType(false).catch(error => {
            console.error('Error loading payment types for enrollment:', error);
          });
        }
      });
      
      if (this.userType) {
        this.userService.customerTypeID = this.userType;
      }
      this.typeSelected = this.userType || 1;
    }, () => { });
    this.enrollmentForm = {} as Enrollment;
    this.enrollmentForm.ApplicantAddress = this.enrollmentForm.ApplicantAddress || {} as ApplicantAddress;
    this.enrollmentForm.billingAddressSame = true;
    this.enrollmentForm.SendEmails = true;
    this.commonData = this.configService.getConfig();
    this.selectedfrequencyTypeID = this.persistentService.retailData.Autoship.FrequencyTypeID;
    this.AutoshipMinDate = moment().add(this.configService.localSettings.Autoship.AutoshipMinDate, 'days').toDate();
    this.AutoshipMaxDate = moment().add(this.configService.localSettings.Autoship.AutoshipMaxDate, 'days').toDate();

    //Maipulating formdata from sessionstorage when page changes
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url.indexOf('complete') == -1 && event.url.indexOf('join') == -1) {
        sessionStorage.setItem('FormData', JSON.stringify(this.enrollmentForm));
      } else if (event instanceof NavigationEnd && event.url == '/join') {
        this.setFormData();
      } else if (event instanceof NavigationEnd && event.url == '/complete') {
        sessionStorage.removeItem('FormData');
      }
    })
  }

  // Add autoship product to cart (subscription)
  addToCartAutoship(product: any) {
    const productToAdd = product._selectedPack || product;
    if (productToAdd?.OutOfStockStatus == 3) {
      return;
    }
    this.cart1Service.addToCart(
      productToAdd,
      true, // show notification
      '',   // custom order code
      true, // isAutoship (subscription)
      false, // fromDialog
      false, // isPack
      true,  // fromApplication
      false, // fromPointbtn
      null,  // countFromSharelink
      false, // loyaltyOrder
      null   // enrollProducts
    );
    localStorage.setItem('params.item', JSON.stringify(productToAdd));
  }

  // Add enrollment kit to cart
  addToCartEnrollment(product: any) {
    const productToAdd = product._selectedPack || product;
    if (productToAdd?.OutOfStockStatus == 3) {
      return;
    }
    
    // Ensure RV value is preserved
    if (productToAdd.RV === undefined || productToAdd.RV === null) {
      productToAdd.RV = 0;
    }
    
    this.cart1Service.addToCart(
      productToAdd,
      true, // show notification
      '',   // custom order code
      false, // isAutoship
      false, // fromDialog
      true,  // isPack (enrollment kit)
      true,  // fromApplication
      false, // fromPointbtn
      null,  // countFromSharelink
      false, // loyaltyOrder
      null   // enrollProducts
    );
    localStorage.setItem('params.item', JSON.stringify(productToAdd));
    
    // Force order recalculation to update RV totals
    setTimeout(() => {
      this.orderService.calculateOrder();
    }, 100);
    
    // Auto-advance to next step (Auto Ship)
    setTimeout(() => {
      this.goToNextStep(0, true); // Step 0 -> Step 1 (Auto Ship)
    }, 200);
  }

  //Setting formdata from session storage to page
  setFormData() {
    if (sessionStorage.getItem('FormData')) {
      this.enrollmentForm = JSON.parse(sessionStorage.getItem('FormData'));
      // Ensure SendEmails is set to true by default even when loading from session storage
      if (this.enrollmentForm.SendEmails === undefined || this.enrollmentForm.SendEmails === null) {
        this.enrollmentForm.SendEmails = true;
      }
    }
  }

  //Setting formdata into session before reload event starts
  @HostListener("window:beforeunload", ["$event"]) saveFormData(event: Event) {
    sessionStorage.setItem('FormData', JSON.stringify(this.enrollmentForm));
  }

  ngOnInit(): void {
    // /join is an enrollment-only checkout. Clear any one-time-order items
    // the user accumulated while browsing /shop so they don't bleed into the
    // SubmitEnrollmentForm Order.Items payload. selectedPacks (Order.Items at
    // submit) and selectedAutoOrderItems (AutoShip.Items at submit) are
    // repopulated by the enrollment form's own product pickers, so we don't
    // touch them. See Griff T-0135.
    this.itemsService.selectedOrderItems = [];
    localStorage.removeItem('cart.order');

    // Normalize to lowercase to match the case used everywhere else
    // (MainComponent, ConfigService, Cart1Service all store lowercase).
    // Using .toUpperCase() here previously flipped selectedCountry from 'us'
    // to 'US' mid-CD-cycle, producing ExpressionChangedAfterItHasBeenCheckedError
    // on HeaderComponent's flag-code binding.
    this.userService.selectedCountry = sessionStorage.getItem('selectedCountry') ? sessionStorage.getItem('selectedCountry').toLowerCase() : DefaultCountry


    // For enrollment flow, always clear payment methods to start fresh
    // This prevents old payment methods from persisting across sessions
    this.userService.paymentMethods = [];
    this.paymentService.clearPayment();

    // Set reference for modal navigation
    this.cart1Service.applicationComponent = this;

    this.product = this.configService.localSettings.Home.PrimaryBanner;
    this.translate.get('global_Company_Title').subscribe((text: string) => {
      this.titleService.setTitle('Join ' + '| ' + text);
    });
    this.getItems("")
    this.days = this.utilityService.birthDays();
    this.months = this.utilityService.birthMonths();
    this.years = this.utilityService.birthYears();
    sessionStorage.setItem('IsEnrollment', 'true');
    this.setSteps(1);

    this.autoshipConfigurationService.autoshipDate = this.autoshipConfigurationService.autoshipDate ?
      this.autoshipConfigurationService.autoshipDate :
      $('#startdate').val();
// check the autoshipconfig
    if (this.autoshipConfigurationService.autoshipDate) {
      $('#startdate').val(this.autoshipConfigurationService.autoshipDate);
    }

    // Enable Disable Steps
    if (this.userService.customerTypeID == 1) {
      setTimeout(() => {
        $('.card').find('.toggle-ul.step_' + 1).slideDown(200);
      }, 2500);
    } else {
      setTimeout(() => {
        $('.card').find('.toggle-ul.step_' + 1).slideDown(200);
      }, 200);
    }

    $('#ds_application2').on('click', (event) => {
      const $target = $(event.target);
      for (let index = 1; index <= this.userService.TotalSteps; index++) {
        if (!$target.closest('#step_' + index).length &&
          $('#step_' + index + ' .step_' + index + '.toggle-ul').length &&
          $('#step_' + index + ' .step_' + index + '.toggle-ul').css('display') != 'none') {
          $('#step_' + index + ' .step_' + index + '.toggle-ul').slideToggle('slow', 'swing', () => {
          });
        }
      }
    });
    this.isShowUpDown[3] = true;
    this.finalStep = this.userService.customerTypeID == 1 ? 6 : 5;

    setTimeout(() => {
      $('html,body').animate({ scrollTop: 0 }, 'slow');
      $(() => {
        this.CurrentSection = {};
        this.CurrentSection[3] = true;
        let countDefault = 0;
        $('#step_3').find('input[type="tel"],input[type="text"]').each(() => {
          if (!$(this).val() && countDefault == 0) {
            $(this).trigger('focus');
            $(this).trigger('select');
            countDefault++;
          }
        });
      });
    }, 1000);
    this.getStates();

    if (sessionStorage.getItem('FormData')) {
      this.enrollmentForm = JSON.parse(sessionStorage.getItem('FormData'));
      // Ensure SendEmails is set to true by default even when loading from session storage
      if (this.enrollmentForm.SendEmails === undefined || this.enrollmentForm.SendEmails === null) {
        this.enrollmentForm.SendEmails = true;
      }
    }

    this.configService.commonSettings.CustomerTypes.forEach((ct) => {
      this.memberTypes.push({
        ID: ct.ID,
        typeName: ct.Description,
        iconName: ct.ID == 1 ? "check" : ct.ID == 2 ? "cart" : "star",
        typeDescription: this.descriptions[ct.ID],
        price: ct.ID == 1 ? '$59.95/Year' : ct.ID == 2 ? 'Free' : '$9.95/Year'
      });
    });

    this.content_display = this.customerTypeDescription();
    // userService customerTypeID

    window.addEventListener('scroll', function() {
      const parent = document.querySelector('.parent-container12');
      const sideCartBox = document.querySelector('#sideCartBox') as any;
      
      const parentRect = parent.getBoundingClientRect();
      const topOffset = Math.max(parentRect.top, 0);
      const maxHeight = Math.min(window.innerHeight - topOffset, parentRect.height);
      
      sideCartBox.style.top = `${topOffset}px`;
      sideCartBox.style.maxHeight = `${maxHeight}px`;
    });

    this.createScrollContent();
    
    // Set up URLs for links
    this.setupUrls();
  }

  setupUrls(): void {
    const origin = window.location.origin;
    const webAlias = this.userService.customerData?.WebAlias || 'www';
    this.privacyPolicyUrl = `${origin}/${webAlias}/privacy-policy`;
    this.termsOfServiceUrl = `${origin}/${webAlias}/terms-of-service`;
  }

  createScrollContent(): void {
    const phrases = [
      "Join the Grove",
      "Community Driven",
      "Turn Passion into Profit",
      "Wellness Business Opportunity",
      "Empower Others",
      "Financial Freedom",
      "Health & Wealth"
    ];
    
    this.scrollContent = [];
    for (let i = 0; i < 6; i++) { // Repeat 6 times to ensure no gaps
      phrases.forEach((phrase, index) => {
        this.scrollContent.push({
          phrase: phrase,
          key: `scroll-${i}-${index}`
        });
      });
    }
  }

  descriptions = {
    "3": "Receive discounted pricing on all products & earn free product through Loyalty Rewards + all the benefits of a Retail Customer.",
    "2": "Enjoy high quality Tangerine.fun products & access to a personal account + personal website.",
    "1": "Earn commissions, bonuses, trainings, business tools, team onboarding + all the benefits of a Preferred customer.",
  };

  changeAffiliate() {
    const dialogRef = this.dialog.open(JoiningdialogComponent, {
      disableClose: true,
      panelClass: 'joining-dialog',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

  itemsForCustomerIBO() {
    // this.getEnrollmentKitItems();
    const requestForkit = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      LanguageCode: this.configService.commonData.selectedLanguage || 'en',
      RegionID: this?.RegionIDForRequest,
      PriceGroup: this.userService.customerTypeID,
      StoreID: "70DC6BB417",
      CategoryId: 0
    };
    // this.getAutoshipItems();
    const requestforAuto = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      LanguageCode: this.configService.commonData.selectedLanguage || 'en',
      RegionID: this?.RegionIDForRequest,
      PriceGroup: this.userService.customerTypeID,
      StoreID: "5",
      CategoryId: 0
    };

    // this.getInitialOrderItems();
    const requestforInitial = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      LanguageCode: this.configService.commonData.selectedLanguage || 'en',
      RegionID: this?.RegionIDForRequest,
      PriceGroup: this.userService.customerTypeID,
      StoreID: "70DC6BB417",
      CategoryId: 0
    };
    // this.getRetailsItems();
    const requestforretail_wholesale = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      LanguageCode: this.configService.commonData.selectedLanguage || 'en',
      RegionID: this?.RegionIDForRequest,
      PriceGroup: this.userService.customerTypeID,
      StoreID: "70DC6BB417",
      CategoryId: 0
    };
    const requestforretail_autoship = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      LanguageCode: this.configService.commonData.selectedLanguage || 'en',
      RegionID: this?.RegionIDForRequest,
      PriceGroup: this.userService.customerTypeID,
      StoreID: "70DC6BB417",
      CategoryId: 0
    };
    const requestforretail_kit = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      LanguageCode: this.configService.commonData.selectedLanguage || 'en',
      RegionID: this?.RegionIDForRequest,
      PriceGroup: this.userService.customerTypeID,
      StoreID: "70DC6BB417",
      CategoryId: 0
    };
    this.itemsService.getProducts(requestForkit).subscribe((p: any[]) => {
      this.productskitStore = this.sortEnrollmentPacksByOrder(p.filter(item => item.Category === "Enrollment"));
      this.productswholesaleStore = p.filter(item => item.Category !== "Enrollment");
      
      // Set RV values for enrollment products if not already set
      this.productswholesaleStore.forEach(item => {
        if (item.RV === undefined || item.RV === null || item.RV === 0) {
          item.RV = item.CV || item.QV || 0; // Fallback to CV or QV if RV not available
        }
      });
      
      // Set RV values for enrollment products if not already set
      this.productskitStore.forEach(item => {
        if (item.RV === undefined || item.RV === null || item.RV === 0) {
          // Set RV based on item ID or other logic
          if (item.ItemID === FreeEnrollmentItemID) {
            item.RV = 125; // Set appropriate RV value for enrollment kit
          } else if (item.ItemID === "23748") {
            item.RV = 35; // Set appropriate RV value for other enrollment items
          } else {
            item.RV = item.CV || item.QV || 0; // Fallback to CV or QV if RV not available
          }
        }
      });
      // Load autoship products from autoship store (ID 5)
      this.itemsService.getProducts(requestforAuto).subscribe((autoship: any[]) => {
        this.productsAutoshipStore = this.sortProductsByHomepageOrder(autoship);
        
        // Set RV values for autoship products if not already set
        this.productsAutoshipStore.forEach(item => {
          if (item.RV === undefined || item.RV === null || item.RV === 0) {
            item.RV = item.CV || item.QV || 0; // Fallback to CV or QV if RV not available
          }
        });
        //comparing retail autoship and normal autoship
        this.productsAutoshipStore.forEach(item => {
          this.productsretailPrice_autoship.forEach(item2 => {
            if (item.ItemID == item2.ItemID) {
              item['RetailPrice'] = item2.Price;
            }
          })
        });
      });

      //comparing retail kit and normal kit
      this.productskitStore.forEach(item => {
        this.productsretailPrice_kit.forEach(item2 => {
          if (item.ItemID == item2.ItemID) {
            item['RetailPrice'] = item2.Price;
          }
        })
      });
      //comparing retail autoship and normal autoship
      this.productsAutoshipStore.forEach(item => {
        this.productsretailPrice_autoship.forEach(item2 => {
          if (item.ItemID == item2.ItemID) {
            item['RetailPrice'] = item2.Price;
          }
        })
      });
      //comparing retail wholesale and normal wholesale
      this.productswholesaleStore.forEach(item => {
        this.productsretailPrice_wholesale.forEach(item2 => {
          if (item.ItemID == item2.ItemID) {
            item['RetailPrice'] = item2.Price;
          }
        })
      });
      //default item to be added in cart in case of ibo item id = 14 in intial order and autoship order

      //this is for initial order item 14 getting item
      this.productskitStore.forEach(item => {
        if(this.itemsService?.selectedPacks?.length == 0){
          if (item.ItemID == FreeEnrollmentItemID) {
            this.defaultproducts.push(item)
          }
        }
      })

      //if length of selected initial items is not 0 then loops through cart to check item 14
      if (this.itemsService.selectedOrderItems.length != 0) {
        let alreadyinCart = false;
        this.itemsService.selectedOrderItems.forEach(item => {
          if (item.ItemID == FreeEnrollmentItemID) {
            alreadyinCart = true;
          }
        })
        if (!alreadyinCart) {
          this.cart1Service.addToCart(this.defaultproducts[0], false, '', false, false, false, true, false)
        }
      }
      //if length of selected initial items is 0 then adds item 14 to cart
      else {
        this.cart1Service.addToCart(this.defaultproducts[0], false, '', false, false, false, true, false)
      }
      //end
      
      // Trigger order service calculations after RV values are set
      setTimeout(() => {
        if (this.itemsService.selectedPacks.length > 0) {
          this.orderService.calculateOrder().then(() => {
            // Force change detection to update the UI
            this.refreshOrderSummary();
          });
        }
        if (this.itemsService.selectedAutoOrderItems.length > 0) {
          this.orderService.calculateAutoOrder().then(() => {
            // Force change detection to update the UI
            this.refreshOrderSummary();
          });
        }
      }, 500);
    })

    //first  call
    // this.itemsService.getProducts(requestforretail_wholesale).subscribe((p: any[]) => {
    //   this.productsretailPrice_wholesale = p;
    //   //second call
    //   this.itemsService.getProducts(requestforretail_kit).subscribe((p: any[]) => {
    //     this.productsretailPrice_kit = p;
    //     //third call
    //     this.itemsService.getProducts(requestforretail_autoship).subscribe((p: any[]) => {
    //       this.productsretailPrice_autoship = p;
    //       //fourth call
    //       this.itemsService.getProducts(requestforInitial).subscribe((p: any[]) => {
    //         // this.productswholesaleStore = p
    //         p.forEach(item => {
    //           if (item.Category != 'CS Merchandise') {
    //             this.productswholesaleStore.push(item)
    //           }
    //         });

    //         //fifth call
    //         this.itemsService.getProducts(requestforAuto).subscribe((p: any[]) => {
    //           this.productsAutoshipStore = p
    //           //sixth call
              
    //         })
    //       })
    //     })
    //   })
    // })
  }

  itemsForCustomerPC() {
    // this.getAutoshipItems();
    const requestforAuto = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      LanguageCode: this.configService.commonData.selectedLanguage || 'en',
      RegionID: this?.RegionIDForRequest,
      PriceGroup: this.userService.customerTypeID,
      StoreID: "5",
      CategoryId: 0
    };
    // this.getInitialOrderItems();
    const requestforInitial = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      LanguageCode: this.configService.commonData.selectedLanguage || 'en',
      RegionID: this?.RegionIDForRequest,
      PriceGroup: this.userService.customerTypeID,
      StoreID: 2,
      CategoryId: 0
    };
    // this.getRetailsItems();
    const requestforretail_wholesale = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      LanguageCode: this.configService.commonData.selectedLanguage || 'en',
      RegionID: this?.RegionIDForRequest,
      PriceGroup: this.userService.customerTypeID,
      StoreID: 2,
      CategoryId: 0
    };
    const requestforretail_autoship = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      LanguageCode: this.configService.commonData.selectedLanguage || 'en',
      RegionID: this?.RegionIDForRequest,
      PriceGroup: this.userService.customerTypeID,
      StoreID: "70DC6BB417",
      CategoryId: 0
    };
    //first  call
    this.itemsService.getProducts(requestforretail_wholesale).subscribe((p: any[]) => {
      this.productsretailPrice_wholesale = p;
      //second call
      this.itemsService.getProducts(requestforretail_autoship).subscribe((p: any[]) => {
        this.productsretailPrice_autoship = p;
        //third call
        this.itemsService.getProducts(requestforInitial).subscribe((p: any[]) => {
          p.forEach(item => {
            if (item.Category != 'CS Merchandise') {
              this.productswholesaleStore.push(item)
            }
          });
          
          // Set RV values for wholesale products if not already set
          this.productswholesaleStore.forEach(item => {
            if (item.RV === undefined || item.RV === null || item.RV === 0) {
              item.RV = item.CV || item.QV || 0; // Fallback to CV or QV if RV not available
            }
          });

          //fourth call
          this.itemsService.getProducts(requestforAuto).subscribe((p: any[]) => {
            this.productsAutoshipStore = this.sortProductsByHomepageOrder(p)
            
            // Set RV values for autoship products if not already set
            this.productsAutoshipStore.forEach(item => {
              if (item.RV === undefined || item.RV === null || item.RV === 0) {
                item.RV = item.CV || item.QV || 0; // Fallback to CV or QV if RV not available
              }
            });
            //comparing retail autoship and normal autoship
            this.productsAutoshipStore.forEach(item => {
              this.productsretailPrice_autoship.forEach(item2 => {
                if (item.ItemID == item2.ItemID) {
                  item['RetailPrice'] = item2.Price;
                }
              })
            });
            //comparing retail wholesale and normal wholesale
            this.productswholesaleStore.forEach(item => {
              this.productsretailPrice_wholesale.forEach(item2 => {
                if (item.ItemID == item2.ItemID) {
                  item['RetailPrice'] = item2.Price;
                }
              })
            });
            // start of adding items for customer id 3
            //this is for initial order item 23748 getting item
            this.productsAutoshipStore.forEach(item => {
              if (item.ItemID == "23748") {
                this.defaultproducts.push(item)
              }
            })
            //if length of selected initial items is not 0 then loops through cart to check item 23748
            if (this.itemsService.selectedOrderItems.length != 0) {
              let alreadyinCart = false;
              this.itemsService.selectedOrderItems.forEach(item => {
                if (item.ItemID == "23748") {
                  alreadyinCart = true;
                }
              })
              if (!alreadyinCart) {
                this.cart1Service.addToCart(this.defaultproducts[0], false, '', false, false, false, true, false)
              }
            }
            //if length of selected items is 0 then adds item 23748 to cart
            else {
              this.cart1Service.addToCart(this.defaultproducts[0], false, '', false, false, false, true, false)
            }
            //end
            
            // Trigger order service calculations after RV values are set
            setTimeout(() => {
              if (this.itemsService.selectedPacks.length > 0) {
                this.orderService.calculateOrder().then(() => {
                  // Force change detection to update the UI
                  this.refreshOrderSummary();
                });
              }
              if (this.itemsService.selectedAutoOrderItems.length > 0) {
                this.orderService.calculateAutoOrder().then(() => {
                  // Force change detection to update the UI
                  this.refreshOrderSummary();
                });
              }
            }, 500);
          })
        })
      })
    })
  }

  customerTypeDescription() {
    let id = JSON.parse(localStorage.getItem('userService'))
    if (!id.customerTypeID){
       return '';
      }else if(id.customerTypeID == 1){
        return 'Fun Ambassador';
      }else if(id.customerTypeID == 2){
        return 'Guest';
      }else if(id.customerTypeID == 3){
        return 'Temporary Customer';
      }else{
        return '';
      }
    
  }

  setSteps(type) {
    this.ApplicationSteps = {
      step1: { currentStep: type == 1 ? 2 : 1 },
      step2: { currentStep: type == 1 ? 3 : 2 },
      step3: { currentStep: type == 1 ? 4 : 3 },
      step4: { currentStep: type == 1 ? 5 : 4 },
      step5: { currentStep: type == 1 ? 6 : 5 }
    };
  }

  getpaymentMethodIframe(data:any) {
    const dialogRef =this.dialog.open(HostedpaymentDialogComponent, {
      'maxHeight': '85%',
      panelClass: 'hosted_payment-Dialog',
      data: {
        IFrameUrl: data,
        Width: data.Width,
        Height: data.Height,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
this.notificationService.success(
  'success',
  this.translate.instant('unifiedapplication_successfully_enrolled')
);



// sessionStorage.removeItem('FormData');
// this.loginFunction(this.enrollmentForm.Email, this.enrollmentForm.Password , this.ProductOrderNumber);

this.router.navigate(['/complete'])
      }}
    )
  }

  setDefaultPayment() {
    this.paymentService.getPaymentType(true).then(() => {
        const saveMethods = this.paymentService.PaymentTypeResponse['SaveMethods'];
        
        // If we have saved methods from server, use them
        if (saveMethods && saveMethods.length > 0) {
            this.userService.paymentMethods = saveMethods;
            this.userService.isPaymentChanged = true;
            localStorage.setItem("userService", JSON.stringify(this.userService));
        } else {
            // If no saved methods from server but we have local payment methods, keep them
            if (this.userService.paymentMethods && this.userService.paymentMethods.length > 0) {
                this.userService.isPaymentChanged = true;
                localStorage.setItem("userService", JSON.stringify(this.userService));
            }
        }
    }).catch(error => {
        console.error("Error fetching payment types:", error);
    });
  }

  getShipName(shipmethodID) {
    this.userService.selectedShippingMethod = shipmethodID;
    this.orderService.calculateOrder();
    if (this.itemsService.selectedAutoOrderItems.length > 0) {
      this.orderService.calculateAutoOrder();
    }
  }

  countPaymentMethods() {
    const paymentMethods = this.userService.paymentMethods;
    return paymentMethods ? paymentMethods.length : 0;
  }

  // Force UI refresh to show payment method
  refreshPaymentMethodDisplay() {
    this.cdr.detectChanges();
    // Also trigger a small delay to ensure the UI updates
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 100);
  }

  submitApplication(cvv?: any) {
    try {


      if (this.itemsService.selectedAutoOrderItems.length > 0 && this.persistentService.retailData.Autoship.FrequencyTypeID <= 0) {
        this.notificationService.error('error_', this.translate.instant('unifiedapplication_choose_frequency_sidecart'));
        return;
      }
      // Allow application with either order items or autoship items
      if (this.userService.customerTypeID == 3 && this.itemsService.selectedOrderItems.length == 0 && this.itemsService.selectedAutoOrderItems.length == 0) {
        this.notificationService.error('error_', this.translate.instant('unifiedapplication_order_item_required'));
        return;
      }
      if (this.userService.customerTypeID == 2 && this.itemsService.selectedOrderItems.length == 0 && this.itemsService.selectedAutoOrderItems.length == 0) {
        this.notificationService.error('error_', this.translate.instant('unifiedapplication_order_item_required'));
        return;
      }
      if (this.userService.customerTypeID == 3 && this.itemsService.selectedAutoOrderItems.length == 0) {
        this.notificationService.error('error_', this.translate.instant('unifiedapplication_autoorder_item_required'));
        return;
      }

      // if (this.userService.customerTypeID == 1 && this.IsAllowKitItems && this.itemsService.selectedPacks.length == 0) {
      //   this.notificationService.error('error_', 'unifiedapplication_kit_item_required');
      //   return;
      // }

      this.IsSubmitDisable = true;

      const productdetails = [];
      _.each(this.itemsService.selectedOrderItems, (item) => {
        productdetails.push({
          ItemID: item.ItemID,
          Quantity: item.Quantity,
          // IsKit: false,
          CurrencyCode: this.companyService.selectedCurrency.CurrencyCode
        });
      });

      _.each(this.itemsService.selectedPacks, (item) => {
        productdetails.push({
          ItemID: item.ItemID,
          Quantity: item.Quantity,
          // IsKit: item.IsKitItem,
          CurrencyCode: this.companyService.selectedCurrency.CurrencyCode
        });
      });

      const autoshipproductdetails = [];
      _.each(this.itemsService.selectedAutoOrderItems, (item) => {
        autoshipproductdetails.push({
          ItemID: item.ItemID,
          Quantity: item.Quantity,
          IsKit: false,
          CurrencyCode: this.companyService.selectedCurrency.CurrencyCode
        });
      });
      this.submitApplicationRequest = {
        AssociateID: this.paymentService.PaymentDataResponse.customerId || "",
        AcceptTerms: true,
        billingAddressSame: false,
        FirstName: this.enrollmentForm.FirstName,
        LastName: this.enrollmentForm.LastName,
        // RomanizedFirstName: '',
        // RomanizedLastName: '',
        // LegalFirstName: '',
        // LegalLastName: '',
        TaxID: this.enrollmentForm.TaxID,
        BirthDate: new Date(
          (this.enrollmentForm.BirthYear || 2000),
          (this.enrollmentForm.BirthMonth || 1),
          (this.enrollmentForm.BirthDay || 1),
        ).toDateString(),
        PrimaryPhone: this.enrollmentForm.PrimaryPhone,
        SecondaryPhone: '',
        TextNumber: '',
        Email: this.enrollmentForm.Email,
        Username: this.enrollmentForm.Username,
        Password: this.enrollmentForm.Password,
        LanguageCode: this.enrollmentForm.LanguageCode || 'en',
        ApplicantAddress: {
          FirstName: String(this.enrollmentForm.FirstName || '').trim(),
          LastName: String(this.enrollmentForm.LastName || '').trim(),
          ShipTo: (this.enrollmentForm.FirstName + ' ' + this.enrollmentForm.LastName).trim(),
          AddressId: 0,
          Street1: this.enrollmentForm.ApplicantAddress.Street1,
          Street2: this.enrollmentForm.ApplicantAddress.Street2,
          Street3: this.enrollmentForm.ApplicantAddress.Street3 || "",
          City: this.enrollmentForm.ApplicantAddress.City,
          Region: this.enrollmentForm.ApplicantAddress?.Region,
          PostalCode: this.enrollmentForm.ApplicantAddress.PostalCode,
          CountryCode: this.userService.selectedCountry || 'us'
        },
        ShippingAddress: {
          FirstName: String(this.enrollmentForm.FirstName || '').trim(),
          LastName: String(this.enrollmentForm.LastName || '').trim(),
          ShipTo: (this.enrollmentForm.FirstName + ' ' + this.enrollmentForm.LastName).trim(),
          AddressId: 0,
          Street1: this.enrollmentForm.ApplicantAddress.Street1,
          Street2: this.enrollmentForm.ApplicantAddress.Street2,
          Street3: this.enrollmentForm.ApplicantAddress.Street3 || "",
          City: this.enrollmentForm.ApplicantAddress.City,
          Region: this.enrollmentForm.ApplicantAddress?.Region,
          PostalCode: this.enrollmentForm.ApplicantAddress.PostalCode,
          CountryCode: this.userService.selectedCountry || 'us'
        },
        AssociateTypeID: this.userService.customerTypeID,
        // AssociateBaseType: this.userService.customerTypeID,
        SponsorID: this.userService.enrollerInfo.CustomerId ||"75D493FAFB",
        WebPageURL: this.enrollmentForm.Username || '',
        // WebPageItemID: 0,
        SendEmails: this.enrollmentForm.SendEmails || false,
        // AssociateCustom: null,
        // PlacementOverrides: null,
        Order: {
          ShipMethodID: this.userService.selectedShippingMethod || "1",
          StoreID: ENROLLMENTSTORE, // Use enrollment store for JOIN flow
          CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
          Items: productdetails,
          CouponCodes: this.userService.couponInfo.Allcoupons || [],
          Payments: [{
            SavePaymentMethodId: (this.userService.paymentMethods[0].PaymentMethodId || this.userService.paymentMethods[0].Token || this.userService.paymentMethods[0].token),
            CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
            MerchantId: this.userService.paymentMethods[0].MerchantId
          }],
          RequireSuccess: true,
        },
      };

      if (autoshipproductdetails.length > 0) {
        this.submitApplicationRequest.AutoShip = {
          StartDate: this.autoshipConfigurationService.autoshipDate,
          Frequency: '2', //this.persistentService.retailData.Autoship.FrequencyTypeID.toString(),
          ShipMethodID: this.userService.selectedShippingMethod || "1",
          Items: autoshipproductdetails
        };
      }

      this.apiService.submitEnrollmentForm(this.submitApplicationRequest).subscribe(
        (result: EnrollmentResponse) => {
          if (result.Message === 'Success') {
            localStorage.setItem(
              'SubmitApplication',
              JSON.stringify(result.Data)
            );
            sessionStorage.removeItem('statusVerified');
            this.userService.webOffice.UserName = this.enrollmentForm.Email;  // Username for login = Email
            this.userService.webOffice.Password = this.enrollmentForm.Password;
            this.userService.webOffice.Email = this.enrollmentForm.Email;
            this.userService.webOffice.CustomWebsiteUrl = this.ReplicatedSiteUrl + '/' + (this.enrollmentForm.Username || '') + '/Home';
            if (this.paymentMerchantData.MerchantId == 3 && this.paymentMerchantData.Name == "Nexio Credit Card") {
              // this.paymentService.getPaymentData(this.paymentMerchantData, undefined, true);
              const iframeData = result.Data.Order.Payment.PaymentUrl;
              this.ProductOrderNumber = result.Data.Order.OrderNumber;
              this.getpaymentMethodIframe(iframeData)
            } else {
              this.router.navigate(['/complete'])

              //  this.loginFunction(this.enrollmentForm.Email, this.enrollmentForm.Password , result.Data.Order.OrderNumber);
            }

          } else {
            // Check for username-specific errors
            const errorMsg = result.Message || result.ErrorDescription || 'unifiedapplication_error_occured_try_again';
            const errorLower = errorMsg.toLowerCase();

            if (errorLower.includes('username') && (errorLower.includes('exist') || errorLower.includes('taken') || errorLower.includes('unavailable'))) {
              this.notificationService.error('error_', 'error_username_exists');
            } else {
              this.notificationService.error('error_', errorMsg);
            }

            try {
              this.IsSubmitDisable = false;
              this.loadingDetails = false;
              document
                .getElementById('placeorder')
                .setAttribute('disabled', '');
              // Check for payment error
              const error = result.Message;
              if (error && error.length && !!~error.indexOf('Failed Payment')) {
                const cardNumberText = 'Index:';
                if (error.indexOf(cardNumberText) > -1) {
                  const cardNumberIndex =
                    error.indexOf(cardNumberText) + cardNumberText.length;
                  const cardNumber =
                    Number(error.slice(cardNumberIndex, cardNumberIndex + 1)) +
                    1;

                  const cardAmountText = 'Amount:';
                  const cardAmountIndex =
                    error.indexOf(cardAmountText) + cardAmountText.length;
                  const cardAmountEndIndex = error.indexOf(
                    ' ',
                    cardAmountIndex
                  );
                  const cardAmount = error.slice(
                    cardAmountIndex,
                    cardAmountEndIndex
                  );

                  this.notificationService.error(
                    'error_',
                    this.translate.instant(
                      'unifiedapplication_enrollment_invalid_card',
                      {
                        cardNumber: cardNumber.toString(),
                        cardAmount: this.currencyFilter(cardAmount)
                      }
                    )
                  );
                } else {
                  this.notificationService.error('error_', result.Message);
                }

                return;
              }

              this.SubmitApplicationResponse = {};
              localStorage.removeItem('SubmitApplication');
              sessionStorage.removeItem('FormData');
              localStorage.setItem(
                'SubmitApplication',
                JSON.stringify(result.Data)
              );
              this.SubmitApplicationResponse = result.Data;
            } catch (ex) {
              console.warn('Application submission error:', ex);
              document
                .getElementById('placeorder')
                .setAttribute('disabled', '');
              this.notificationService.error(
                'error_',
                this.translate.instant(
                  'unifiedapplication_error_occured_try_again'
                )
              );
              this.IsSubmitDisable = false;
            }
          }
        },
        err => {
          // document.getElementById('placeorder').setAttribute('disabled', '');
          this.IsSubmitDisable = false;
          this.loadingDetails = false;
          console.error(err);

          // Extract error message from various possible locations
          let errorDescription = null;
          if (err.error) {
            errorDescription = err.error.ErrorDescription || err.error.ErrorMessage || err.error.Message || err.error.message;
          }

          // Check for username-specific errors
          if (errorDescription) {
            const errorLower = errorDescription.toLowerCase();
            if (errorLower.includes('username') && (errorLower.includes('exist') || errorLower.includes('taken') || errorLower.includes('unavailable'))) {
              this.notificationService.error('error_', 'error_username_exists');
              return;
            }
          }

          // Show specific error if available, otherwise show generic error
          if (errorDescription) {
            this.notificationService.error('error_', errorDescription);
          } else {
            this.notificationService.error(
              'error_',
              this.translate.instant('unifiedapplication_error_occured_try_again')
            );
          }
        },
        () => { }
      );
      // document.getElementById('placeorder').setAttribute('enabled', '');
    } catch (e) {
      this.IsSubmitDisable = false;
      this.notificationService.error(
        'error_', this.translate.instant('unifiedapplication_error_occured_try_again')
      );
    }

  }
  currencyFilter(amount) {
    return amount;
  }
  togglePanel() {
    this.userService.sponsorSectionPanel = !this.userService.sponsorSectionPanel;
  }
  verifyUsername(username: string) {
    if (username) {
      const blockword = ['test,abuse'];
      const isValidPost = this.validateKeyword.CheckValidation(blockword, username);
      if (isValidPost && !isValidPost.isvalid) {
        this.notificationService.error(
          'error_',
          this.translate.instant('username_not_available_')
        );
        const UserNameCheck = false;
        this.enrollmentForm.Username = '';
      } else {
        this.apiService.validateUsername(username).subscribe(
          result => {
            try {
              if (result.Status == 0 && result.Data) {
                this.notificationService.success(
                  'success',
                  this.translate.instant('username_available_')
                );
              } else {
                this.enrollmentForm.Username = '';
                this.notificationService.error(
                  'error_',
                  this.translate.instant('username_not_available_')
                );

              }
            } catch (ex) {
              this.notificationService.error(
                'error_',
                this.translate.instant('error_occured_try_again')
              );
            }
          },
          err => {
            // Do stuff whith your error
            this.loadingDetails = false;
          },
          () => {

          }
        );
      }
    }
  }

  verifyUserNameAndEmail(email: string) {
    if (email) {
      this.enrollmentForm.Email = email.replace(/\s/g, '');
      const filter = new RegExp('^([\\w-\\.+]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\\]?)$');
      if (this.enrollmentForm.Email && filter.test(this.enrollmentForm.Email)) {
        this.apiService
          .validateEmailAddress({ EmailAddress: email })
          .subscribe(result => {
            if (!result.Data) {
              this.notificationService.error('error_', 'error_email_exists');
              this.enrollmentForm.Email = '';
            } else {
              this.notificationService.success('success', 'email_available_');
              this.userService.personalInfo.Email = email;
            }
          });
      }
    }
  }

  public updatecountry(country, languagecode) {
    if (country.CountryCode == 'jp') {
      //window.location.href = 'https://www.Tangerine.funww.jp/Tangerine.fun/enroll/'
    } else {
      this.cart1Service.updateCountry(country, languagecode, false, false);
    }
  }

  // Mailing Address

  regexValidateZip(countrycode) {

    const regxExp = this.regexService.getRegex(countrycode.toUpperCase());
    const filter = new RegExp(regxExp);
    if (filter.test(this.enrollmentForm.ApplicantAddress.PostalCode)) {
      this.showError = false;
      this.getShippingTypes();
    }
    else {
      this.showError = true;
    }
  }
  public getShippingTypes() {

    if(this.userService.shippingAddress == null){
      this.userService.shippingAddress = {} as ShippingAddress;
    }

    this.userService.shippingAddress.Street1 = this.enrollmentForm.ApplicantAddress?.Street1;
    this.userService.shippingAddress.Street2 = this.enrollmentForm.ApplicantAddress?.Street2;
    this.userService.shippingAddress.City = this.enrollmentForm.ApplicantAddress?.City;
    this.userService.shippingAddress.PostalCode = this.enrollmentForm.ApplicantAddress?.PostalCode;
    this.userService.shippingAddress.Region = this.enrollmentForm.ApplicantAddress?.Region;
    this.orderService.calculateOrderCall = true;
    this.orderService.calculateOrder().then(() => {
      let shipM = '';
      _.each(this.userService.shippingMethods, (shipmethod) => {
        if (this.userService.selectedShippingMethod && this.userService.selectedShippingMethod == shipmethod.ShipMethodID) {
          shipM = shipmethod.ShipMethodID;
        }
      });
      if (shipM == '') {
        shipM = this.userService.shippingMethods && (this.userService.shippingMethods[0]?.ShipMethodID || this.userService.shippingMethods[0]?.ShipMethodId);
      }
      this.userService.selectedShippingMethod = shipM;
    });
    if (this.itemsService.selectedAutoOrderItems.length > 0) {
      this.orderService.calculateAutoOrder();
    }
  }

  getAvailableShippingMethods() {
    if (!this.userService.shippingMethods) {
      return [];
    }
    return this.userService.shippingMethods.filter(
      (shipmethod: any) => shipmethod.ShipMethodId !== 16
    );
  }

  getStates() {
    this.apiService.getStates(this.country.CountryCode || DefaultCountry).subscribe((result) => {
      sessionStorage.setItem(DefaultCountry + 'State', JSON.stringify(result.Data));
      if (result.Data && result.Data.length > 0) {
        this.StatesResponse = result.Data;
        // this.enrollmentForm.ApplicantAddress?.Region = result.Data[0].StateCode;
        // this.userService.mailingAddress.StateName =
        //   this.userService.mailingAddress.StateName || result.Data[0].StateName;          
        if (this.userService.selectedCountry == DefaultCountry || this.userService.selectedCountry == 'us') {
          if(this.enrollmentForm?.ApplicantAddress){
            this.enrollmentForm.ApplicantAddress.Region = "UT"
          }
          if(this.userService?.shippingAddress){
            this.userService.shippingAddress.Region = 'UT';
          }
          result.Data.forEach((x => {
            if (x.StateCode == "UT") {
              this.userService.mailingAddress.StateName =
                this.userService.mailingAddress.StateName || result.Data[0].StateName;
            }
          }));
        } else {
          if(this.userService?.shippingAddress){
            this.userService.shippingAddress.Region = result.Data[0].StateCode;
          }
          this.userService.mailingAddress.StateName =
          this.userService.mailingAddress?.StateName || result.Data[0].StateName;
          if(this.enrollmentForm?.ApplicantAddress){
            this.enrollmentForm.ApplicantAddress.Region = result.Data[0].StateCode;
          }
        }
        if (!this.StateNameToggel) {
          this.getStateName(false);
          this.StateNameToggel = true;
        }
      }
    },
      (error) => {
      }, () => {

      });
  }

  getStateName(isMailingAddress) {
    if (isMailingAddress) {
      // The applicant-address state <mat-select> binds to enrollmentForm.ApplicantAddress.Region.
      // Reading userService.mailingAddress.State here lost the user's selection and produced an
      // empty filter result, then crashed on [0].StateName when the user picked a state.
      const selectedStateCode =
        this.enrollmentForm?.ApplicantAddress?.Region ||
        this.userService.mailingAddress?.State ||
        this.userService.defaultState;
      const matched = _.filter(this.StatesResponse, (state: any) => state.StateCode === selectedStateCode);
      this.userService.mailingAddress.StateName = matched[0]?.StateName ?? '';
      if (this.userService.paymentMethods.length > 0) {
        this.userService.paymentMethods = [];
        this.notificationService.warning('warn_', 'unifiedapplication_fill_payment_again_state');
      }
    } else {
        //@ts-ignore
        this.userService.shippingAddress?.Region = _?.filter(
        this.StatesResponse, (state: any) => {
          return (
            state.StateCode ===
            (this.userService.shippingAddress?.Region || this.userService?.defaultState)
          );
        }
      )[0]?.StateCode;
    }
    this.enrollmentForm.ApplicantAddress.PostalCode = "";
    this.getShippingTypes();
  }

  checkAddress() {
    if (this.enrollmentForm.FirstName && this.enrollmentForm.LastName && this.enrollmentForm.ApplicantAddress.Street1 &&
      this.enrollmentForm.ApplicantAddress.City && this.enrollmentForm.ApplicantAddress?.Region && this.enrollmentForm.ApplicantAddress.PostalCode && this.enrollmentForm.PrimaryPhone) {
      return true;
    }
    return false;
  }

  getQuanity() {
    let quantity = 0;
    _.each(this.itemsService.selectedPacks, (item) => {
      quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
    });

    _.each(this.itemsService.selectedOrderItems, (item) => {
      if (!item.UsePoints) {
        quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
      }
      if (item.UsePoints) {
        quantity += (item.rewardQuantity ? parseInt(item.rewardQuantity, 10) : 0);
      }
    });
    _.each(this.itemsService.selectedAutoOrderItems, (item) => {
      quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
    });
    return quantity;
  }

  getOrderQuanity() {
    let quantity = 0;
    _.each(this.itemsService.selectedOrderItems, (item) => {
      if (!item.UsePoints) {
        quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
      }
      if (item.UsePoints) {
        quantity += (item.rewardQuantity ? parseInt(item.rewardQuantity, 10) : 0);
      }
    });
    return quantity;
  }

  getPacksQuanity() {
    let quantity = 0;
    _.each(this.itemsService.selectedPacks, (item) => {
      quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
    });
    return quantity;
  }

  getAutoOrderQuanity() {
    let quantity = 0;
    _.each(this.itemsService.selectedAutoOrderItems, (item) => {
      quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
    });
    return quantity;
  }

  getItems(type: string) {
    return this.itemsService[type == 'pack' ? 'selectedPacks' : (type == 'autoship' ? 'selectedAutoOrderItems' : 'selectedOrderItems')];
  }

  getImage(item) {
    return (item.OptionsImage && item.ImageUrl.substr(0, item.ImageUrl.lastIndexOf('/'))
      .concat(item.OptionsImage)) || item.ImageUrl;
  }

  closeCart() {
    //let newUrl: any;
    if (this.itemsService.selectedAutoOrderItems.length === 0 && this.itemsService.selectedOrderItems.length === 0 && this.itemsService.selectedPacks.length === 0) {
      // Check if user is logged in
      if (this.isLoggedIn()) {
        return; // Don't allow enrollment if user is already logged in
      }

      if (this.userService.customerTypeID == 1) {
        this.router.navigate(['/join'],
          {
            relativeTo: this.activatedRoute,
            queryParams: { type: 1 },
            queryParamsHandling: 'merge'
          }).then(() => { window.location.reload(); });
      }

      else if (this.userService.customerTypeID == 3) {
        this.router.navigate(['/join'],
          {
            relativeTo: this.activatedRoute,
            queryParams: { type: 3 },
            queryParamsHandling: 'merge'
          }).then(() => { window.location.reload(); });
      }

      else {
        this.router.navigate(['/join'])
      }
    }
  }

  increaseQuantiy(type, item) {
    this.cart1Service.increaseQuantiy(item, type == 'autoship', type == 'pack');
  }

  decreaseQuantiy(type, item) {
    if (this.getQuantityModel(type, item)[item.ItemID] == 1 && this.userService.customerTypeID === 1) {
      this.notificationService.error('error_', this.translate.instant('unifiedapplication_cannot_delete_item'));
    } else {
      this.cart1Service.decreaseQuantiy(item, type == 'autoship', type == 'pack');
    }
  }

  removeFromCart(type, item) {
    this.cart1Service.removeFromCart(item, type == 'autoship', type == 'pack', true, this.productskitStore);
  }

  getQuantityModel(type, item): any {
    return this.cart1Service[type == 'pack' ? 'packQuantity' : (type == 'autoship' ? 'autoshipQuantity' : ((item && item.UsePoints) ? 'orderRewardQuantity' : 'orderQuantity'))];
  }

  checkQuantity(type, item) {
    const quantity = this.getQuantityModel(type, item)[item.ItemID];
    if (!Number(quantity)) {
      this.cart1Service.removeFromCart(item, type == 'autoship', type == 'pack', true);
    } else {
      item.Quantity = quantity;
      if (type == 'autoship') {
        localStorage.setItem('cart.autoship', JSON.stringify(this.itemsService.selectedAutoOrderItems));
        this.orderService.calculateAutoOrder();
      } else {
        localStorage.setItem((type == 'pack' ? 'cart.packs' : 'cart.order'), JSON.stringify(type == 'pack' ? this.itemsService.selectedPacks : this.itemsService.selectedOrderItems));
        this.orderService.calculateOrder();
      }
    }
  }

  getLastQuantity(type, item) {
    this.lastQuantity = this.getQuantityModel(type, item)[item.ItemID];
  }


  checkcart() {

    if (this.userService.customerTypeID == 1) {
       let alreadyinCart = true;
      // this.itemsService.selectedOrderItems.forEach(item => {
      //   if (item.ItemID == FreeEnrollmentItemID || item.ItemID == FreeEnrollmentZeroPriceItemID) {
      //     alreadyinCart = true;
      //   }
      // })
      if(this.showError){
        this.notificationService.error('error_', 'Please enter the valid zip code.');
      }

      if (alreadyinCart) {
        // License agreement is required for Fun Ambassadors
        if (!this.checkboxes.accept4) {
          this.notificationService.error('error_', this.translate.instant('unifiedapplication_license_agreement_required'));
          return;
        }
        this.check();
      } else {
        this.notificationService.error('error_', this.translate.instant('Please_add_Annual_Membership_Item_in_cart'))
      }

    } else if (this.userService.customerTypeID == 3) {
      let alreadyinCart = false;
      this.itemsService.selectedOrderItems.forEach(item => {
        if (item.ItemID == 23748) {
          alreadyinCart = true;
        }
      })

      // if (alreadyinCart) {
      //   this.check();
      // } else {
      //   this.notificationService.error('error_', this.translate.instant('Please_add_Annual_Membership_Item_in_cart'))
      // }

    } else {
      this.check()
    }
  }

  checkPayment() {
    if (this.userService.paymentMethods.length > 0) {
      if (this.userService.paymentMethods[0].Last4 || this.userService.paymentMethods[0].Last4 === undefined) {
        return true;
      } else {
        this.notificationService.error('error_', this.translate.instant('unifiedapplication_add_payment_error'));
        return false;
      }
    } else {
      this.notificationService.error('error_', this.translate.instant('unifiedapplication_add_payment_error'));
      return false;
    }
  }

  // Payment Section
  addSavePayment(paymentData) {
    this.paymentMerchantData=paymentData;
    if (this.enrollmentForm.ApplicantAddress?.Region) {
      if (!this.utilityService.isEmptyObject(this.paymentService.SelectedPaymentTypes) && (this.paymentService.SelectedPaymentTypes.MerchantId !== paymentData.MerchantId)) {
        this.userService.paymentMethods = [];
      }
      this.paymentService.SelectedPaymentTypes = paymentData;
      this.paymentService.selectedPaymentTypeName = this.paymentService.SelectedPaymentTypes.DisplayName;
      if (this.paymentService.SelectedPaymentTypes.CanSavePayments) {
        this.paymentService.OldSelectedPaymentType = this.paymentService.SelectedPaymentTypes;
        this.paymentService.getPaymentData(paymentData, undefined, true).then(() => {
          this.setDefaultPayment();
          // Force UI refresh to show the payment method
          this.refreshPaymentMethodDisplay();
        });
      } else {
        this.paymentService.oldSelectedPaymentTypeName = this.paymentService.selectedPaymentTypeName;
        this.userService.paymentMethods = [];
        const selectpay = {
          CardType: this.paymentService.SelectedPaymentTypes.CardType || this.paymentService.SelectedPaymentTypes.Name,
          Last4: this.paymentService.SelectedPaymentTypes.Ending,
          ExpireMonth: this.paymentService.SelectedPaymentTypes.Expires ? moment(this.paymentService.SelectedPaymentTypes.Expires).format('M') : 0,
          ExpireYear: this.paymentService.SelectedPaymentTypes.Expires ? moment(this.paymentService.SelectedPaymentTypes.Expires).format('YYYY') : 0,
          Token: this.paymentService.SelectedPaymentTypes.PaymentMethodId ? this.paymentService.SelectedPaymentTypes.PaymentMethodId : '',
          MerchantId: this.paymentService.SelectedPaymentTypes.MerchantId
        };
        this.userService.paymentMethods.push(selectpay);
        this.userService.isPaymentChanged = true;
        // Force UI refresh to show the payment method
        this.refreshPaymentMethodDisplay();
      }
      localStorage.setItem('userService', JSON.stringify(this.userService));
    }
    else {
      this.notificationService.error('error_', 'please_enter_your_address');
    }
  }

  check() {
    if (!this.checkPayment()) {
      return;
    } else {
      this.submitApplication();
    }
  }

  validatePromoCode() {
    if (this.userService.couponInfo.promoCode) {
      if (this.userService.couponInfo.availableRewards.length) {
        _.each(this.userService.couponInfo.availableRewards, (awailablereward) => {
          if (awailablereward.Code.toLowerCase() == this.userService.couponInfo.promoCode.toLowerCase()) {
            this.userService.couponInfo.RewardsForUse.push(awailablereward);
          }
        });
      }
    }
    this.userService.couponInfo.IsAppliedcode = true;
    this.orderService.calculateOrder().then((result) => {
      if (result && this.userService.couponInfo.promoCode) {
        _.each(this.orderService.calculateOrderResponse.CouponResults, (item) => {
          const isInCart = this.userService.couponInfo.Allcoupons.some((code) => {
            if (code.toLowerCase() == item.Code.toLowerCase()) {
              return true;
            }
            return false;
          });

          if (item.IsValid) {
            if (!isInCart) {
              this.userService.couponInfo.Allcoupons.push(item.Code);
            }
            if (this.userService.couponInfo.promoCode == item.Code) {
              this.notificationService.success('success', 'coupon_added_success');
            }
            this.userService.couponInfo.promoCodeValid = true;
            this.userService.couponInfo.promoCode = '';
          } else {
            this.userService.couponInfo.promoCodeValid = false;
            this.userService.couponInfo.IsAppliedcode = false;
            this.userService.couponInfo.promoCode = '';
            if (isInCart && this.itemsService.selectedOrderItems.length) {
              this.userService.couponInfo.Allcoupons = this.userService.couponInfo.Allcoupons.filter((code) => {
                return code.toLowerCase() != item.Code.toLowerCase();
              });
              this.userService.couponInfo.RewardsForUse = this.userService.couponInfo.RewardsForUse.filter((e) => {
                return e.Code.toLowerCase() != item.Code.toLowerCase();
              });

            }
          }

        });
      }
    });
  }

  isCouponCode(Coupon) {
    const NewCustomerPromo = 'NewCustomerPromo_' + this.userService.customerData.BackOfficeId;
    if (Coupon && (Coupon.Code === NewCustomerPromo || Coupon.Code === this.userService.DynamicCouponCode.promoCode)) {
      return false;
    } else {
      return true;
    }
  }

  removePromo(code) {
    this.userService.couponInfo.RewardsForUse = _.reject(this.userService.couponInfo.RewardsForUse, (e) => {
      return e.Code.toLowerCase() == code.toLowerCase();
    });
    this.userService.couponInfo.promoCode = '';
    this.userService.couponInfo.promoCodeValid = true;
    this.userService.couponInfo.IsAppliedcode = false;
    this.userService.couponInfo.Allcoupons = _.without(this.userService.couponInfo.Allcoupons, code);
    this.orderService.calculateOrder();
  }

  loginFunction(userName, pass ,orderId) {
    // check the data
    this.loadingDetails = true;
    const loginrequest = {
      granttype: 'password',
      scope: 'office',
      username: userName,
      password: pass
    };
    this.apiService.Login(loginrequest).subscribe(
      (result) => {
        if (result && result.status == 200 && result.body.Status != 1) {
          const res: any = result.body;
          var autoshipItems:any = [];
          var standardItems:any = [];
          try {
            autoshipItems = JSON.parse(localStorage.getItem('cart.autoship')) || [];
            standardItems = JSON.parse(localStorage.getItem('cart.order')) || [];
          } catch (error) {
          }
          if (orderId > 0) {
            try {
              var items :any = [];
              this.submitApplicationRequest.Order.Items.forEach(ele=>{
                this.itemsService.getProduct(ele.ItemID).subscribe(product => {
                  items.push({
                    "itemId": product.ItemID,
                    "productName": product.ProductName,
                    "sku": product.SKU,
                    "quantity": ele.Quantity,
                    "qv": product.QV,
                    "cv": product.CV,
                    "bonus": product.Bonus,
                    "price": product.Price,
                    "languageCode": product.LanguageCode,
                    "currencyCode": product.CurrencyCode,
                  })
                });
              })
              var orderdata = [{
                "orderId": orderId,
                "customerId": res.CustomerId,
                "sponsorId": res.SponsorId,
                "orderDetail": {
                  "items":items,
                  "subTotal": this.orderService.calculateOrderResponse.SubTotal || 0,
                  "totalAmount": this.orderService.calculateOrderResponse.Total || 0
                }
              }]
              var tempData = JSON.stringify(orderdata);
              //window['ZTM'].setStats('Tangerine.fun',"PlaceOrder",tempData);
            } catch (error) {
            }
          }
          if (this.submitApplicationRequest.AutoShip) {
            this.apiService.getCustomerAutoships(res.CustomerId).subscribe((result: any) => {
              try {
                if (Number(result.Status) === 0) {
                  if (result.Data && result.Data.length > 0) {
                    var items :any = [];
                    this.submitApplicationRequest.AutoShip?.Items.forEach(ele=>{
                      autoshipItems.forEach(product => {
                        if (parseInt(product.ItemID) == ele.ItemID) {
                          items.push({
                            "itemId": product.ItemID,
                            "productName": product.ProductName,
                            "sku": product.SKU,
                            "quantity": ele.Quantity,
                            "qv": product.QV,
                            "cv": product.CV,
                            "bonus": product.Bonus,
                            "price": product.Price,
                            "languageCode": product.LanguageCode,
                            "currencyCode": product.CurrencyCode,
                          })
                        }
                      });
                    })
                    var Autodata = [{
                      "orderId": result.Data[0].AutoShipID,
                      "customerId": res.CustomerId,
                      "sponsorId": res.SponsorId,
                      "orderDetail": {
                        "items":items,
                        "subTotal": this.orderService.calculateAutoOrderResponse.SubTotal || 0,
                        "totalAmount": this.orderService.calculateAutoOrderResponse.Total || 0
                      }
                    }]
                    var tempData = JSON.stringify(Autodata);
                    //window['ZTM'].setStats('Tangerine.fun',"PlaceOrder",tempData);
                  }
                }
              } catch (ex) {
                console.error('ex', ex);
              }
            }, (error) => {
            }, () => { });
          }
          try {
          var data = [{
            "customerId": res.CustomerId,
            "backOfficeId": res.BackOfficeId,
            "emailaddress": res.EmailAddress,
            "phoneNumber": res.PrimaryPhone,
            "firstName": res.FirstName,
            "lastName": res.LastName,
            "customerStatus": res.CustomerStatus,
            "customerType": res.CustomerType,
            "username": res.Username,
            "webAlias": res.WebAlias,
            "sponsorId": res.SponsorId,
            "enrollerId": res.EnrollerId,
            "signupDate": res.SignupDate,
            "primaryAddress": {
              "id": res.PrimaryAddress?.ID,
              "line1": res.PrimaryAddress?.Line1,
              "line2": res.PrimaryAddress?.Line2,
              "line3": res.PrimaryAddress?.Line3,
              "city": res.PrimaryAddress?.City,
              "state": res.PrimaryAddress?.State,
              "zip": res.PrimaryAddress?.Zip,
              "countryCode": res.PrimaryAddress?.CountryCode,
            },
            "defaultShippingAddress": {
              "id": res.DefaultShippingAddress.ID,
              "line1": res.DefaultShippingAddress.Line1,
              "line2": res.DefaultShippingAddress.Line2,
              "line3": res.DefaultShippingAddress.Line3,
              "city": res.DefaultShippingAddress.City,
              "state": res.DefaultShippingAddress.State,
              "zip": res.DefaultShippingAddress.Zip,
              "countryCode": res.DefaultShippingAddress.CountryCode,
            },
            "externalReferenceId": res.ExternalReferenceId,
            "languageCode": res.LanguageCode,
          }]
          var data1 = JSON.stringify(data);
          //window['ZTM'].setStats('Tangerine.fun','CreateCustomer',data1);
          } catch (error) {
          }
          try {
            localStorage.setItem('isLoggedIn', 'true');
            this.accountService.getCustomerData(res.CustomerId).then((data: any) => {
              if (data && data.Data) {
                localStorage.setItem('user', JSON.stringify(data.Data));
                this.userService.customerData = data.Data;

                this.userService.customerTypeID = this.userService.customerData.CustomerType;
                this.userService.customerData.shippingAddress = {};
                if (this.userService.customerData.DefaultShippingAddress && !this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)) {
                  this.user.setShippingAddress();
                } else {
                  this.userService.shippingAddress = null;
                }
                this.userService.customerTypeID = this.userService.customerData.CustomerType;
                if (this.userService.customerData.WebAlias) {
                  this.apiService.validateWebAlias(this.userService.customerData.WebAlias).subscribe((res: any) => {
                    if (res.Data) {
                      this.userService.WebAlias = this.userService.customerData.WebAlias;
                      this.router.navigate(['/complete']);
                      this.userService.paymentMethods = [];
                    }
                    this.router.navigate(['/complete']);  
                  }, (error) => {
                    if (error.Data && !error.Data.WebAlias) {
                      this.notificationService.error('error_', 'webalias_not_exists');
                      return false;
                    }
                  },
                    () => {

                    });
                }
                else if (this.userService.customerData.SponsorId || this.userService.customerData.EnrollerId) {
                  this.apiService.getSearchCustomerDetail(this.userService.customerData.SponsorId || this.userService.customerData.EnrollerId).subscribe((resp: any) => {
                    if (resp.Data) {
                      this.apiService.validateWebAlias(resp.Data.WebAlias).subscribe((res: any) => {
                        if (res.Data) {
                          this.userService.WebAlias = resp.Data.WebAlias;
                          this.router.navigate(['/complete']);
                          this.userService.paymentMethods = [];
                        }
                      }, (error) => {
                        if (error.Data && !error.Data) {
                          this.notificationService.error('error_', 'webalias_not_exists');
                          return false;
                        }
                      },
                        () => {

                        });
                    }
                  }, (error) => {
                    if (error.Data && !error.Data.WebAlias) {
                      this.notificationService.error('error_', 'webalias_not_exists');
                      return false;
                    }
                  },
                    () => {

                    });
                }
              } else {
                // Always clear cart when logging in since members get different pricing
                this.clearCartAndRedirectToMemberStore();
              }
            });
          } catch (successEx) {
            this.notificationService.error('error_', 'error_occured_try_again');
            console.error('ex', successEx);
          }
        } else {
          this.notificationService.error('error_', 'Authentication Failed');
        }
      }, err => {
        this.notificationService.error('error_', 'error_occured_try_again');
      },
      () => {

      });
  }

  setFrequency() {
    this.commonData.FrequencyTypes.some((freq) => {
      if (freq.ID == this.persistentService.retailData.Autoship.FrequencyTypeID) {
        this.persistentService.retailData.Autoship.FrequencyTypeID = freq.ID;
        this.persistentService.retailData.Autoship.FrequencyTypeID = freq.ID;
        this.persistentService.retailData.Autoship.FrequencyTypeDescription = freq.Description;
        this.persistentService.retailData.isChanged = true;
        return;
      }
    });
  }

  myFilter = (d: Date): boolean => {
    const date = d?.getDate();
    return (
      date !== 30 &&
      date !== 31
    );
  };
  ngOnDestroy() {
    sessionStorage.setItem('IsLegacyUnifiedEnrollment', null);
    if(!this.isLoggedIn()){
      this.userService.customerTypeID = 2;
      localStorage.getItem("cart.order")
        ? localStorage.removeItem("cart.order")
        : null;
        localStorage.getItem("cart.autoship")
        ? localStorage.removeItem("cart.autoship")
        : null;
        localStorage.getItem("cart.packs")
        ? localStorage.removeItem("cart.packs")
        : null;
      this.cart1Service.clearCart();
    }
  }

  rightPosition: string = '25px';

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    const screenWidth = event.target.innerWidth;

    if (screenWidth > 3000) {
      this.rightPosition = '30%';
    } else if (screenWidth > 2560) {
      this.rightPosition = '25%';
    } else if (screenWidth > 1920) {
      this.rightPosition = '20%';
    } else if (screenWidth > 1600) {
      this.rightPosition = '15%';
    } else if (screenWidth > 1440) {
      this.rightPosition = '5%';
    } else {
      this.rightPosition = '25px';
    }
  }
  isSidebarFixed :any
  // @HostListener('window:scroll', [])
  /*onWindowScroll() {
    const sidebarOffset = 0; 
    const scrollPosition = window.pageYOffset;
    const applicationdetail = document.querySelector('.paymentmethodScroll');
    if (applicationdetail) {
      const shopNowSectionBottom = applicationdetail.getBoundingClientRect().bottom;
      if (scrollPosition >= sidebarOffset && screen.width > 768 && scrollPosition < (shopNowSectionBottom-scrollPosition)) {
        this.isSidebarFixed = 1;
      }
       else {
        this.isSidebarFixed = 0;

      }
    }
  }*/
  CollapseTogglebtn(data: any) {
    if (data == 1) {
      this.CollapseToggleEnrollment = !this.CollapseToggleEnrollment
    }
    if (data == 2) {
      this.CollapseToggleTodays = !this.CollapseToggleTodays
    }
    if (data == 3) {
      this.CollapseToggleLoyalty = !this.CollapseToggleLoyalty
    }
  }
  currentStepIndex: number = 0; 
  @ViewChild("stepper") EnrollmentStepper: MatStepper;
  goToNextStep(stepNumber: number, isNext, isCheckCart?: boolean): void {
    const hasOrderItems = this.itemsService.selectedOrderItems.length > 0;
    const hasPacks = this.itemsService.selectedPacks.length > 0;
    const hasAutoshipItems = this.itemsService.selectedAutoOrderItems.length > 0;
    
    // For enrollment, we only need at least one pack or autoship item
    if (hasPacks || hasAutoshipItems) {
      // Move to the next step (current step + 1)
      this.currentStepIndex = stepNumber + 1;
      // Update the stepper's selected index to actually move to the next step
      if (this.EnrollmentStepper) {
        this.EnrollmentStepper.selectedIndex = this.currentStepIndex;
      }
    } else {
      this.notificationService.error('Error', 'Please select at least one enrollment pack to proceed.');
      return;
    } 
  }

  goToPreviousStep(): void {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex = this.currentStepIndex - 1;
      this.EnrollmentStepper.selectedIndex = this.currentStepIndex;
    }
  }
  onStepChange(event: any) {
    const newIndex = event.selectedIndex;
    const currentIndex = event.previouslySelectedIndex;
    if(newIndex === 2){
      event.selectedStep._editable = false;
    }
    if (this.validateStep(newIndex, currentIndex)) {
      this.currentStepIndex = newIndex;
      this.handleStepperSkip(newIndex);
    } else {
      this.currentStepIndex = currentIndex;
      this.EnrollmentStepper.selectedIndex = currentIndex;
      this.notificationService.error('Error', 'You must complete Step 2 before proceeding to Step 3.');
      return;
    }
    this.updateStepColors(newIndex);
  }
  updateStepColors(currentIndex: number) {
    setTimeout(() => {
      const stepHeaders = document.querySelectorAll('.mat-step-header');
  
      stepHeaders.forEach((el, index) => {
        const stepIcon = el.querySelector('.mat-step-icon');
  
        if (index < currentIndex) {
          stepIcon?.setAttribute('style', 'background-color: green !important;');
        } else if (index === currentIndex) {
          stepIcon?.setAttribute('style', 'background-color: #cb0e82 !important;');
        } else {
          stepIcon?.setAttribute('style', 'background-color: #4BA6E2 !important;');
        }
      });
    }, 100);
  }
  validateStep(stepIndex: number, currentIndex: number): boolean {
    // Now we only have 3 steps: 0 (Kit), 1 (Auto), 2 (Pay)
    // Users can go from step 0 to step 1, or step 1 to step 2
    if (currentIndex === 0 && stepIndex === 2) {
      return false; // Can't skip from Kit directly to Pay
    }
    return true;
  }
  ngAfterViewInit() {
    this.handleStepperSkip(this.EnrollmentStepper?.selectedIndex);
  }
  handleStepperSkip(selectedIndex: number) {
    const StepHeaders = Array.from(document.querySelectorAll('mat-step-header'));
    StepHeaders.map((header) => {
      if(header.id === `cdk-step-label-0-${selectedIndex}`) {
        for (let index = 0; index < this.EnrollmentStepper._steps.length; index++) {
          const nextStepper:HTMLElement = document.querySelector(`#cdk-step-label-0-${index}`);
          if(!nextStepper) {
            return;
          }
          if(index <= selectedIndex) {
            (nextStepper.style.pointerEvents = "auto");
          } else {
            (nextStepper.style.pointerEvents = "none");
          }
        }
      }
    });
  }
  isLoggedIn() {
    if (
      Object.keys(this.userService.customerData).length &&
      this.userService.customerData.CustomerId &&
      this.user.checkIfUserAuthenticatedOrNot()
    ) {
      return true;
    } else {
      return false;
    }
  }

  validatewebalias(request: any) {
    if (!request) {
      return;
    }
    this.apiService.validateWebAlias(request).subscribe((res: any) => {
      if (res.Data) {
        this.notificationService.success("success", "Webalias Available")
      } else {
        this.notificationService.error(
          "error_",
          "webalias Not Available"
        );
        const UserNameCheck = false;
        this.enrollmentForm.Username = '';
      }
    },
      (error) => {
        if (error.Data && !error.Data.WebAlias) {
          this.notificationService.error(
            "error_",
            "webalias_not_exists",
          );
          return false;
        }
      },
      () => { },)
  }

  // Method to handle pack selection change
  onPackSelectionChange(product: any, selectedPack: any) {
    if (product._isGrouped) {
      product._selectedPack = selectedPack;
      // Don't modify the original product object, just update the selected pack reference
    }
  }

  // Method to get pack size display name
  getPackDisplayName(product: any): string {
    if (!product.ProductName) return '';
    
    const packMatch = product.ProductName.match(/(\d+)pk/i);
    if (packMatch) {
      return `${packMatch[1]} Pack`;
    }
    
    return 'Single';
  }

  // Method to format product name
  formatProductName(productName: string): string {
    if (!productName) return 'Product';
    return productName;
  }

  // Method to format price
  formatPrice(price: number): string {
    if (!price) return '$0.00';
    return `$${price.toFixed(2)}`;
  }

  formatRV(rv: number): string {
    if (!rv) return '';

    // Format as "X RV" like marketplace
    return `${rv} RV`;
  }

  // Method to get product variant for styling
  getProductVariant(index: number): string {
    const variants = ['green', 'yellow', 'orange'];
    return variants[index % variants.length];
  }

  // Method to refresh order summary display
  refreshOrderSummary() {
    // Force change detection
    setTimeout(() => {
      // This will trigger Angular's change detection
    }, 0);
  }

  // Method to get manual order total for display
  getManualOrderTotal(): number {
    let total = 0;
    
    // Add pack totals
    this.itemsService.selectedPacks.forEach(item => {
      total += (item.Quantity || 1) * (item.Price || 0);
    });
    
    // Add order item totals
    this.itemsService.selectedOrderItems.forEach(item => {
      total += (item.Quantity || 1) * (item.Price || 0);
    });
    
    return total;
  }

  // Method to get manual RV total for display
  getManualRVTotal(): number {
    let total = 0;
    
    // Add pack RV totals
    this.itemsService.selectedPacks.forEach(item => {
      total += (item.Quantity || 1) * (item.RV || 0);
    });
    
    // Add order item RV totals
    this.itemsService.selectedOrderItems.forEach(item => {
      total += (item.Quantity || 1) * (item.RV || 0);
    });
    
    return total;
  }

  // Method to sort products by homepage order
  sortProductsByHomepageOrder(products: any[]): any[] {
    // Define the order based on homepage product sequence
    const homepageOrder = [
      'metabology matrix',
      'metabology ω3',
      'metabology lean',
      'photonic activator',
      'metabology am',
      'metabology pm',
      'metabology am/pm',
      'rose gold elixir',
      'charcoal cleanser',
      'beauty collection'
    ];

    // Create a map for quick lookup
    const orderMap = new Map<string, number>();
    homepageOrder.forEach((name, index) => {
      orderMap.set(name.toLowerCase(), index);
    });

    // Sort products based on homepage order
    return products.sort((a, b) => {
      const aOrder = this.findBestMatch(a.ProductName, orderMap);
      const bOrder = this.findBestMatch(b.ProductName, orderMap);
      return aOrder - bOrder;
    });
  }

  // Helper method to find best match for product name
  findBestMatch(productName: string, orderMap: Map<string, number>): number {
    if (!productName) return 999; // Put unknown products at the end
    
    const nameLower = productName.toLowerCase();
    
    // Check for exact match first
    if (orderMap.has(nameLower)) {
      return orderMap.get(nameLower)!;
    }
    
    // Check for partial matches
    for (const [orderedName, index] of orderMap) {
      if (nameLower.includes(orderedName) || orderedName.includes(nameLower)) {
        return index;
      }
    }
    
    // Check for key terms
    if (nameLower.includes('matrix')) return orderMap.get('metabology matrix') || 999;
    if (nameLower.includes('ω3') || nameLower.includes('omega')) return orderMap.get('metabology ω3') || 999;
    if (nameLower.includes('lean')) return orderMap.get('metabology lean') || 999;
    if (nameLower.includes('photonic') || nameLower.includes('activator')) return orderMap.get('photonic activator') || 999;
    if (nameLower.includes('am') && !nameLower.includes('pm')) return orderMap.get('metabology am') || 999;
    if (nameLower.includes('pm') && !nameLower.includes('am')) return orderMap.get('metabology pm') || 999;
    if (nameLower.includes('am/pm') || nameLower.includes('am+pm')) return orderMap.get('metabology am/pm') || 999;
    if (nameLower.includes('rose') || nameLower.includes('elixir')) return orderMap.get('rose gold elixir') || 999;
    if (nameLower.includes('charcoal') || nameLower.includes('cleanser')) return orderMap.get('charcoal cleanser') || 999;
    if (nameLower.includes('beauty') || nameLower.includes('collection')) return orderMap.get('beauty collection') || 999;
    
    return 999; // Put unknown products at the end
  }

  // Method to sort enrollment packs
  sortEnrollmentPacksByOrder(products: any[]): any[] {
    // Sort by price descending - most expensive first
    const sorted = [...products].sort((a, b) => {
      const priceA = a.Price ?? 0;
      const priceB = b.Price ?? 0;
      if (priceB !== priceA) {
        return priceB - priceA;
      }
      return (a.ProductName || '').localeCompare(b.ProductName || '');
    });
    // Flip top row order (reverse first 4 items)
    const top = sorted.slice(0, 4).reverse();
    return [...top, ...sorted.slice(4)];
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  clearCartAndRedirectToMemberStore() {
    // Clear all cart data from localStorage
    localStorage.removeItem('cart.order');
    localStorage.removeItem('cart.autoship');
    localStorage.removeItem('cart.packs');
    localStorage.removeItem('cartItem'); // Regular cart service
    
    // Clear sessionStorage cart data
    sessionStorage.removeItem('cart');
    
    // Clear cart items from services
    this.itemsService.selectedOrderItems = [];
    this.itemsService.selectedAutoOrderItems = [];
    this.itemsService.selectedPacks = [];
    
    // Clear order calculation responses
    if (this.orderService) {
      this.orderService.calculateOrderResponse = {};
      this.orderService.calculateAutoOrderResponse = {};
    }
    
    // Clear cart service completely
    if (this.cart1Service) {
      this.cart1Service.clearCart();
    }
    
    // Force refresh cart UI by triggering cart service updates
    if (this.shoppingCartService) {
      this.shoppingCartService.shoppingCart = [];
    }
    
    // Set marketplace store ID
    sessionStorage.setItem('selectedStoreId', this.storeConstantsService.getCurrentStoreConstants().MEMBERSTORE);
    
    // Redirect to marketplace with a message
    this.notificationService.success('success_', 'Welcome! Cart cleared - member pricing now available');
    
    // Navigate to marketplace and force page reload to ensure clean state
    this.router.navigate(['/marketplace']).then(() => {
      // Small delay to ensure navigation completes, then reload
      setTimeout(() => {
        window.location.reload();
      }, 100);
    });
  }
}
